import React from "react";
import { CardHeader, IconButton } from "@material-ui/core/";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

export default function SummaryHeader(props) {
    const { title, handleFunction, valueExpanded } = props;
    return (
        <CardHeader
            title={title}
            action={
                <IconButton
                    onClick={handleFunction}
                    aria-expanded={valueExpanded}
                    aria-label="Show more"
                >
                    {!valueExpanded ? (
                        <AddIcon fontSize="large" color="primary" />
                    ) : (
                        <RemoveIcon fontSize="large" color="primary" />
                    )}
                </IconButton>
            }
        ></CardHeader>
    );
}
